import { HttpStatusCode } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';
import { hr } from 'src/app/shared/model/admin-user-dto';
import { AppUsersDto } from 'src/app/shared/model/app-users-dto';
import { CommonService } from 'src/app/shared/service/common.service';
import { LoggedInUserKeys, LoggedInUserService } from 'src/app/shared/service/logged-in-user.service';

@Component({
    selector: 'app-change-password-form',
    templateUrl: './change-password-form.component.html',
    standalone: false
})
export class ChangePasswordFormComponent {
  @Input() resetPasswordForm: FormGroup;
  showPassword: boolean = false;
  oldPassword: boolean = false;
  newPassword: boolean = false;
  confirmPassword: boolean = false;
  showImageForValidEmail = false;
  confirmPasswordNotValid: boolean = false;
  @Output() close = new EventEmitter();
  @Output() isAdded = new EventEmitter();
  @Input() getLoginEmail: string;
  @Output() confirmPasswordCheck = new EventEmitter();
  loginUser: AppUsersDto;
  HrDto: hr = new hr();
  constructor(
    public readonly _commonService: CommonService,
    private readonly fb: FormBuilder,
    private readonly _router: Router,
    private readonly _adminService: AdminService,
    private readonly _loggedInUserService: LoggedInUserService,
    private readonly _toaster: ToastrService
  ) { }
  ngOnInit() {
    this.loginUser = this._loggedInUserService.getLoggedInUser(
      LoggedInUserKeys.LOGGED_IN_USER
    )
  }
  oldPasswordToggle() {
    this.oldPassword = !this.oldPassword;
  }
  newPasswordToggle() {
    this.newPassword = !this.newPassword;
  }
  confirmPasswordToggle() {
    this.confirmPassword = !this.confirmPassword;
  }


  changePassword(data) {
    this.HrDto.email = this.getLoginEmail;
    this.HrDto.oldPassword = this._commonService.encryptValue(data.oldPassword);
    this.HrDto.newPassword = this._commonService.encryptValue(data.newPassword);
    this.HrDto.confirmPassword = this._commonService.encryptValue(data.confirmPassword);
    let role = JSON.parse(
      localStorage.getItem('loggedInUser')
    )?.userRole;
    if(role == 'CANDIDATE'){
       this._adminService.candidateChangePassword(this.HrDto).subscribe({
        next:(response)=>{
          if (response.statusCode === HttpStatusCode.Ok) {
            this.closePopUp()
            this._toaster.success('Password changed successfully', 'success');
            this._router.navigate([this._commonService.Navigations.SIGN_IN]);
            this._loggedInUserService.clearEntireStorage();
          }
        },
        error:(error)=>{
          console.log(error);
          if (error.statusCode == 500) {
            this._toaster.error(error?.error?.message);
          } 
        }
    })
    }else{
    this._adminService.changePassword(this.HrDto).subscribe({
      next:(response)=>{
        if (response.statusCode === HttpStatusCode.Ok) {
          this._toaster.success(response.message, 'success');
          this._router.navigate([this._commonService.Navigations.USER_SIGN_IN]);
          this._loggedInUserService.clearEntireStorage();
        }
      },
      error:(error)=>{
        console.log(error);        
      }
    });
    }
  }





  confirmPasswordMatched(event) {
    this.confirmPasswordCheck.emit(event.target.value)
  }



  closePopUp() {
    this.close.emit();
    this.resetPasswordForm.reset()
  }
}
